<template>
	<div class="switch-language">
		<div class="switch-language-button" @click="switchLanguage('en')" :class="{ active: $i18n.locale === 'en' }">
			<div class="flag-icon">
				<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve">
					<path style="fill:#41479B;" d="M503.172,423.725H8.828c-4.875,0-8.828-3.953-8.828-8.828V97.104c0-4.875,3.953-8.828,8.828-8.828h494.345c4.875,0,8.828,3.953,8.828,8.828v317.793C512,419.772,508.047,423.725,503.172,423.725z"/>
					<path style="fill:#F5F5F5;" d="M512,97.104c0-4.875-3.953-8.828-8.828-8.828h-39.495l-163.54,107.147V88.276h-88.276v107.147L48.322,88.276H8.828C3.953,88.276,0,92.229,0,97.104v22.831l140.309,91.927H0v88.276h140.309L0,392.066v22.831c0,4.875,3.953,8.828,8.828,8.828h39.495l163.54-107.147v107.147h88.276V316.578l163.54,107.147h39.495c4.875,0,8.828-3.953,8.828-8.828v-22.831l-140.309-91.927H512v-88.276H371.691L512,119.935V97.104z"/>
					<g>
						<polygon style="fill:#FF4B55;" points="512,229.518 282.483,229.518 282.483,88.276 229.517,88.276 229.517,229.518 0,229.518 0,282.483 229.517,282.483 229.517,423.725 282.483,423.725 282.483,282.483 512,282.483 	"/>
						<path style="fill:#FF4B55;" d="M178.948,300.138L0.25,416.135c0.625,4.263,4.14,7.59,8.577,7.59h12.159l190.39-123.586h-32.428V300.138z"/>
						<path style="fill:#FF4B55;" d="M346.388,300.138H313.96l190.113,123.404c4.431-0.472,7.928-4.09,7.928-8.646v-7.258L346.388,300.138z"/>
						<path style="fill:#FF4B55;" d="M0,106.849l161.779,105.014h32.428L5.143,89.137C2.123,90.54,0,93.555,0,97.104V106.849z"/>
						<path style="fill:#FF4B55;" d="M332.566,211.863L511.693,95.586c-0.744-4.122-4.184-7.309-8.521-7.309h-12.647L300.138,211.863H332.566z"/>
					</g>
				</svg>
			</div>
			<div class="language-name">English</div>
		</div>
		<div class="switch-language-button" @click="switchLanguage('cs')" :class="{ active: $i18n.locale === 'cs' }">
			<div class="flag-icon">
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">
					<path style="fill:#41479B;" d="M3.256,421.59L256,256L3.256,90.41C1.311,92.029,0,94.375,0,97.103v317.793C0,417.625,1.311,419.971,3.256,421.59z"/>
					<path style="fill:#FF4B55;" d="M3.256,421.59c1.53,1.274,3.425,2.134,5.571,2.134h494.345c4.875,0,8.828-3.953,8.828-8.828V256H256L3.256,421.59z"/>
					<path style="fill:#F5F5F5;" d="M3.256,90.41c1.53-1.274,3.425-2.134,5.571-2.134h494.345c4.875,0,8.828,3.953,8.828,8.828V256H256L3.256,90.41z"/>
				</svg>
			</div>
			<div class="language-name">Čeština</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {UserService} from "../../services/UserService";
	import {mapState} from "vuex";

	export default {
		name: "SwitchLanguage",
		computed: {
			...mapState([ "currentUser", "device" ]),
		},
		methods: {
			switchLanguage(language) {
				localStorage.setItem("language", language);
				this.$store.commit("setDevice", { ...this.device, language });
				this.$i18n.locale = language;
				if (this.currentUser) {
					Vue.nextTick(() => {
						UserService.saveUserInfo();
					});
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.switch-language {
		display: flex;
		padding-bottom: 10px;

		.switch-language-button {
			margin: 0 10px 0 10px;
			padding: 5px 10px 0 10px;
			display: flex;
			flex-direction: row;
			text-align: center;
			cursor: pointer;
			justify-content: space-between;
			align-items: center;

			.flag-icon {
				width: 40px;

				svg {
					width: 40px;
				}
			}

			.language-name {
				font-size: 16px;
				padding: 5px 5px 5px 10px;
			}

			&.active {
				border: 1px solid rgba(0, 0, 0, 0.35);
				background-color: rgba(0, 0, 0, 0.15);
			}
		}
	}
</style>
